export default __webpack_public_path__ + "static/media/uploader-oneTouchUltra2-1.a6adac8b.png";